import { gql, TypedDocumentNode } from "@apollo/client";

import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";
import { isEmpty } from "src/utils/arrays.utils.ts";

import {
  BlacklistTypesSchemasQuery,
  BlacklistTypesSchemasQueryVariables,
} from "../../__generated__/graphql";

export const getBlacklistTypesSchemasQuery = gql(`
    query BlacklistTypesSchemas {
        schema {
            blacklists {
                code
                name
            }
        }
    }`) as TypedDocumentNode<BlacklistTypesSchemasQuery, BlacklistTypesSchemasQueryVariables>;

export const useGetBlacklistTypesSchemasQuery = () => {
  return useFetchQuery(getBlacklistTypesSchemasQuery, {
    toData: (data) => {
      return data?.schema?.blacklists ?? [];
    },
    isEmpty: (data) => isEmpty(data?.schema?.blacklists),
    uiErrors: {
      fetchError: "FETCH-BLACKLIST-TYPES-ERROR",
      emptyError: "EMPTY-BLACKLIST-TYPES-ERROR",
    },
  });
};
